import { maunaSpaceAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import MaunaHeader from './MaunaHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface MaunaSpaceDataType {
  id: number;
  publish: boolean;
  title: string;
  description: string;
  category: number;
  floor: string | null;
  img: string;
  detail: any;
  link: string;
  link_faview: string;
  latlng: string;
  sgroup_id: number | null;
  createdAt: string;
  updatedAt: string;
}

const columnHelper = createColumnHelper<MaunaSpaceDataType>();

const categoryMap: { [key: string]: string } = {
  '1': '객실',
  '2': '다이닝',
  '3': '부대시설',
  '4': '웨딩&연회',
};

const getColumns = (): ColumnDef<MaunaSpaceDataType, any>[] => {
  const baseColumns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('title', {
      header: '이름',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('description', {
      header: '설명',
      cell: (info) => {
        const text = info.getValue() || '';
        return text.length > 10 ? `${text.slice(0, 10)}...` : text;
      },
    }),
    columnHelper.accessor('category', {
      header: '카테고리',
      cell: (info) =>
        categoryMap[info.getValue().toString()] || info.getValue(),
    }),
    columnHelper.accessor('floor', {
      header: '층',
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('publish', {
      header: '앱 사용 여부',
      cell: (info) => (info.getValue() ? '사용' : '미사용'),
    }),
    columnHelper.accessor('updatedAt', {
      header: '수정일',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<MaunaSpaceDataType, any>[];
};

const MaunaContainer = () => {
  return (
    <CommonSpaceListContainer<MaunaSpaceDataType>
      HeaderComponent={MaunaHeader}
      queryKey="getSpacesMauna"
      queryFn={() =>
        maunaSpaceAPI.getSpaces({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/mauna/space"
      buttonColor="resom"
      showCreateButton={false}
    />
  );
};

export default MaunaContainer;
